import gql from 'graphql-tag';

export const fragments = {
  documentItem: gql`
    fragment documentItem on DocumentItem {
      id
      documentId
      abbreviatedStatement
      fullStatement
      humanCodingScheme
      createdAt
      modifiedAt
    }`,
  document: gql`
    fragment documentItem on DocumentItem {
      id
      documentId
      abbreviatedStatement
      fullStatement
      humanCodingScheme
      createdAt
      modifiedAt
    }`,
};

export const workspaceknowledgeMapListFragments = {
  workspace: gql`
    fragment workspace on Workspace {
      id
      competencyDocuments {
        edges {
          node {
            id
            title
          }
        }
      }
    }`,
};

export const workspaceDocumentFragments = {
  document: gql`
    fragment document on Document {
        id
        title
        items {
          edges {
            node {
              id
              documentId
              abbreviatedStatement
              fullStatement
              humanCodingScheme
              createdAt
              modifiedAt
              associationsTo {
                edges {
                  node {
                    originItemId
                    destinationItemId
                    associationType
                    id
                  }
                }
              }
              associationsFrom {
                edges {
                  node {
                    originItemId
                    destinationItemId
                    associationType
                    id
                  }
                }
              }
            }
          }
        }
    }
  `,
};

export default gql`
query getDocument($workspaceId: UUID!, $documentId: UUID!) {
  workspace(workspaceId: $workspaceId) {
    id
    competencyDocuments(documentId: $documentId) {
      edges {
        node {
          id
          title
          items {
            edges {
              node {
                ...documentItem
                associationsTo {
                  edges {
                    node {
                      originItemId
                      destinationItemId
                      associationType
                      id
                    }
                  }
                }
                associationsFrom {
                  edges {
                    node {
                      originItemId
                      destinationItemId
                      associationType
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
${fragments.documentItem}
`;
